import { render, staticRenderFns } from "./AmountGrant.vue?vue&type=template&id=5ea6bf7f&"
import script from "./AmountGrant.vue?vue&type=script&lang=js&"
export * from "./AmountGrant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports